import { VehicleDetailsInput } from './vehicle-details-input.model';


export class GeofenceVehicleAddInput implements IGeofenceVehicleAddInput {
    /** The auto-generated id of the geofence master */
    geofenceId!: number;
    vehicleData!: VehicleDetailsInput[];

    constructor(data?: IGeofenceVehicleAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofenceId = _data["geofenceId"];
            if (Array.isArray(_data["vehicleData"])) {
                this.vehicleData = [] as any;
                for (let item of _data["vehicleData"])
                    this.vehicleData!.push(VehicleDetailsInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeofenceVehicleAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceVehicleAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofenceId"] = this.geofenceId;
        if (Array.isArray(this.vehicleData)) {
            data["vehicleData"] = [];
            for (let item of this.vehicleData)
                data["vehicleData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGeofenceVehicleAddInput {
    /** The auto-generated id of the geofence master */
    geofenceId: number;
    vehicleData: VehicleDetailsInput[];
}

